class ResultsShowcaseSlider {
  constructor(container) {
    this.container = container;
    this.swiper = null;
    this.globalListeners = [];
    this.slidersState = {};
    this.watchIntervals = {};
    this.customSlider = {
      wrapper: null,
      slides: [],
      currentIndex: 0,
      slideWidth: 394,
      activeSlideWidth: 472,
      gap: 12
    };
    this.animatedStats = null;
    this.statsObserver = null;

    this.init();
  }

  init() {
    if (window.innerWidth >= 990) {
      this.initCustomSlider();
    } else {
      this.initSwiper();
    }
    this.initStatsAnimation();
    this.bindEvents();
  }

  initCustomSlider() {
    
    this.customSlider.wrapper = this.container.querySelector('.results-showcase__custom-wrapper');
    if (!this.customSlider.wrapper) {
      return;
    }
    
    this.customSlider.slides = Array.from(this.container.querySelectorAll('.results-showcase__custom-slide'));
    
    if (this.customSlider.slides.length === 0) {
      return;
    }
    if (this.customSlider.slides.length > 0) {
      this.customSlider.slides[0].classList.add('active');
      this.customSlider.currentIndex = 0;
    }
    
    this.updateSliderPosition();
    this.initCustomNavigation();
    
    setTimeout(() => {
      this.initBeforeAfterSliders();
    }, 200);
    
  }
  
  initSwiper() {
    if (window.innerWidth >= 990) {
      return;
    }
    
    const swiperElement = this.container.querySelector('.results-showcase__swiper');
    if (!swiperElement) {
      return;
    }

    const totalSlides = swiperElement.querySelectorAll('.swiper-slide').length;
    
    this.swiper = new Swiper(swiperElement, {
      slidesPerView: 1,
      spaceBetween: 18,
      loop: true,
      grabCursor: true,
      noSwiping: true,
      noSwipingClass: 'results-showcase__slider-container',
      navigation: {
        nextEl: '.results-showcase__nav-next',
        prevEl: '.results-showcase__nav-prev',
      },
      pagination: {
        el: '.results-showcase__pagination',
        clickable: true,
        dynamicBullets: false,
        renderBullet: function (index, className) {
          return '<span class="' + className + '"></span>';
        }
      },
      a11y: {
        prevSlideMessage: 'Résultat précédent',
        nextSlideMessage: 'Résultat suivant',
        firstSlideMessage: 'Premier résultat',
        lastSlideMessage: 'Dernier résultat'
      },
      on: {
        init: () => {
          setTimeout(() => {
            this.initBeforeAfterSliders();
          }, 200);
        },
        slideChange: () => {
        }
      }
    });
  }

  updateActiveSlide(newIndex) {
    this.customSlider.slides.forEach(slide => {
      slide.classList.remove('active');
    });
    if (this.customSlider.slides[newIndex]) {
      this.customSlider.slides[newIndex].classList.add('active');
      this.customSlider.currentIndex = newIndex;
    }
  }
  
  updateSliderPosition() {
    if (!this.customSlider.wrapper) return;
    
    let translateX = 0;
    for (let i = 0; i < this.customSlider.currentIndex; i++) {
      if (i === 0 || (i < this.customSlider.currentIndex && this.customSlider.slides[i].classList.contains('active'))) {
        translateX += this.customSlider.activeSlideWidth + this.customSlider.gap;
      } else {
        translateX += this.customSlider.slideWidth + this.customSlider.gap;
      }
    }
    
    this.customSlider.wrapper.style.transform = `translateX(-${translateX}px)`;
  }
  
  initCustomNavigation() {
    const prevButton = this.container.querySelector('.results-showcase__nav-button.prev');
    const nextButton = this.container.querySelector('.results-showcase__nav-button.next');
    const paginationContainer = this.container.querySelector('.results-showcase__custom-pagination');
    
    if (!prevButton || !nextButton || !paginationContainer) {
      return;
    }
    paginationContainer.innerHTML = '';
    this.customSlider.slides.forEach((slide, index) => {
      const dot = document.createElement('span');
      dot.className = `dot ${index === 0 ? 'active' : ''}`;
      dot.addEventListener('click', () => {
        this.goToSlide(index);
      });
      paginationContainer.appendChild(dot);
    });
    prevButton.addEventListener('click', () => {
      this.prevSlide();
    });
    nextButton.addEventListener('click', () => {
      this.nextSlide();
    });
    
  }
  
  goToSlide(index) {
    if (index < 0 || index >= this.customSlider.slides.length) return;

    this.updateActiveSlide(index);
    this.updateSliderPosition();
    this.updatePaginationDots();

    setTimeout(() => {
      this.initBeforeAfterSliders();
    }, 100);
  }
  
  nextSlide() {
    const nextIndex = (this.customSlider.currentIndex + 1) % this.customSlider.slides.length;
    this.goToSlide(nextIndex);
  }
  
  prevSlide() {
    const prevIndex = this.customSlider.currentIndex === 0 
      ? this.customSlider.slides.length - 1 
      : this.customSlider.currentIndex - 1;
    this.goToSlide(prevIndex);
  }
  
  updatePaginationDots() {
    const dots = this.container.querySelectorAll('.results-showcase__custom-pagination .dot');
    dots.forEach((dot, index) => {
      dot.classList.toggle('active', index === this.customSlider.currentIndex);
    });
  }

  setupPositionWatcher(handle, line, beforeImage, afterImage, slideIndex) {
    const watchInterval = setInterval(() => {
      const savedPosition = handle.dataset.currentPosition;
      const currentPosition = handle.style.left;
      if (this.slidersState[slideIndex] && this.slidersState[slideIndex].isDragging) {
        return;
      }
      if (savedPosition && savedPosition !== currentPosition) {
        handle.style.left = savedPosition;
        line.style.left = savedPosition;
        beforeImage.style.clipPath = `polygon(0% 0%, ${savedPosition} 0%, ${savedPosition} 100%, 0% 100%)`;
        afterImage.style.clipPath = `polygon(${savedPosition} 0%, 100% 0%, 100% 100%, ${savedPosition} 100%)`;
      }
    }, 100);
    this.watchIntervals[slideIndex] = watchInterval;
  }

  initBeforeAfterSliders() {

    Object.values(this.watchIntervals).forEach(interval => clearInterval(interval));
    this.watchIntervals = {};

    if (this.globalDragHandlers) {
      document.removeEventListener('mousemove', this.globalDragHandlers.move);
      document.removeEventListener('mouseup', this.globalDragHandlers.end);
      document.removeEventListener('touchmove', this.globalDragHandlers.move);
      document.removeEventListener('touchend', this.globalDragHandlers.end);
    }

    let slides;
    if (window.innerWidth >= 990) {
      slides = this.container.querySelectorAll('.results-showcase__custom-slide');
    } else {
      slides = this.container.querySelectorAll('.results-showcase__slide');
    }

    this.slideElements = {};

    slides.forEach((slide, slideIndex) => {
      
      const handle = slide.querySelector('.results-showcase__slider-handle');
      const line = slide.querySelector('.results-showcase__slider-line');
      const beforeImage = slide.querySelector('.results-showcase__before-image');
      const afterImage = slide.querySelector('.results-showcase__after-image');
      const sliderContainer = slide.querySelector('.results-showcase__slider-container');
      
      if (!handle || !line || !beforeImage || !afterImage || !sliderContainer) {
        return;
      }

      this.slideElements[slideIndex] = {
        handle,
        line,
        beforeImage,
        afterImage,
        sliderContainer
      };

      this.slidersState[slideIndex] = {
        isDragging: false,
        wasDragging: false
      };
      const initialPosition = '50%';
      handle.style.left = initialPosition;
      line.style.left = initialPosition;
      beforeImage.style.clipPath = `polygon(0% 0%, ${initialPosition} 0%, ${initialPosition} 100%, 0% 100%)`;
      afterImage.style.clipPath = `polygon(${initialPosition} 0%, 100% 0%, 100% 100%, ${initialPosition} 100%)`;
      handle.dataset.currentPosition = initialPosition;
      
      this.setupPositionWatcher(handle, line, beforeImage, afterImage, slideIndex);

      handle.dataset.slideIndex = slideIndex;

      const onMouseDown = (e) => {
        const idx = parseInt(e.currentTarget.dataset.slideIndex);
        const elements = this.slideElements[idx];
        if (elements) {
          this.onDragStart(e, idx, elements.handle, elements.line, elements.beforeImage, elements.afterImage, elements.sliderContainer);
        }
      };

      const onTouchStart = (e) => {
        const idx = parseInt(e.currentTarget.dataset.slideIndex);
        const elements = this.slideElements[idx];
        if (elements) {
          this.onDragStart(e, idx, elements.handle, elements.line, elements.beforeImage, elements.afterImage, elements.sliderContainer);
        }
      };

      const onClick = (e) => {
        const idx = parseInt(e.currentTarget.dataset.slideIndex);
        if (this.slidersState[idx] && this.slidersState[idx].wasDragging) {
          e.preventDefault();
          e.stopPropagation();
          this.slidersState[idx].wasDragging = false;
        }
      };

      handle.addEventListener('mousedown', onMouseDown);
      handle.addEventListener('touchstart', onTouchStart, { passive: false });
      handle.addEventListener('click', onClick);

    });

    this.globalDragHandlers = {
      move: (e) => {
        Object.keys(this.slidersState).forEach(idx => {
          if (this.slidersState[idx] && this.slidersState[idx].isDragging) {
            const elements = this.slideElements[idx];
            if (elements) {
              this.onDragMove(e, idx, elements.handle, elements.line, elements.beforeImage, elements.afterImage, elements.sliderContainer);
            }
          }
        });
      },
      end: (e) => {
        Object.keys(this.slidersState).forEach(idx => {
          if (this.slidersState[idx] && this.slidersState[idx].isDragging) {
            const elements = this.slideElements[idx];
            if (elements) {
              this.onDragEnd(e, idx, elements.handle, elements.line, elements.beforeImage, elements.afterImage, elements.sliderContainer);
            }
          }
        });
      }
    };

    document.addEventListener('mousemove', this.globalDragHandlers.move);
    document.addEventListener('mouseup', this.globalDragHandlers.end);
    document.addEventListener('touchmove', this.globalDragHandlers.move, { passive: false });
    document.addEventListener('touchend', this.globalDragHandlers.end);

  }

  onDragStart(e, slideIndex, handle, line, beforeImage, afterImage, sliderContainer) {
    
    if (!this.slidersState[slideIndex]) return;
    
    this.slidersState[slideIndex].isDragging = true;
    this.slidersState[slideIndex].wasDragging = false;
    
    if (this.swiper && window.innerWidth < 990) {
      this.swiper.disable();
    }
    
    e.preventDefault();
  }

  onDragMove(e, slideIndex, handle, line, beforeImage, afterImage, sliderContainer) {
    if (!this.slidersState[slideIndex] || !this.slidersState[slideIndex].isDragging) return;
    
    this.slidersState[slideIndex].wasDragging = true;
    
    const rect = sliderContainer.getBoundingClientRect();
    const clientX = e.touches ? e.touches[0].clientX : e.clientX;
    const x = clientX - rect.left;
    const percentage = Math.max(0, Math.min(100, (x / rect.width) * 100));
    const position = `${percentage}%`;
    handle.style.left = position;
    line.style.left = position;
    beforeImage.style.clipPath = `polygon(0% 0%, ${position} 0%, ${position} 100%, 0% 100%)`;
    afterImage.style.clipPath = `polygon(${position} 0%, 100% 0%, 100% 100%, ${position} 100%)`;
    handle.dataset.currentPosition = position;
    
    e.preventDefault();
  }

  onDragEnd(e, slideIndex, handle, line, beforeImage, afterImage, sliderContainer) {
    if (!this.slidersState[slideIndex] || !this.slidersState[slideIndex].isDragging) return;
    
    
    this.slidersState[slideIndex].isDragging = false;
    if (this.swiper && window.innerWidth < 990) {
      this.swiper.enable();
    }
    setTimeout(() => {
      if (this.slidersState[slideIndex]) {
        this.slidersState[slideIndex].wasDragging = false;
      }
    }, 100);
  }

  initStatsAnimation() {
    const statNumbers = this.container.querySelectorAll('.results-showcase__stat-number');

    if (statNumbers.length === 0) return;

    this.animatedStats = new Set();

    this.statsObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting && !this.animatedStats.has(entry.target)) {
          this.animatedStats.add(entry.target);
          this.animateStat(entry.target);
        }
      });
    }, {
      threshold: 0.1
    });

    statNumbers.forEach((statElement, index) => {
      this.statsObserver.observe(statElement);
    });
  }

  animateStat(statElement) {
    const finalValue = statElement.textContent.trim();

    if (!statElement.dataset.finalValue) {
      statElement.dataset.finalValue = finalValue;
    }

    const valueToAnimate = statElement.dataset.finalValue;

    const match = valueToAnimate.match(/^(-?[\d.,]+)(.*)$/);
    if (!match) {
      return;
    }

    const numericValue = parseFloat(match[1].replace(',', '.'));
    const suffix = match[2].trim();

    if (isNaN(numericValue)) {
      return;
    }

    let currentValue = 0;
    const duration = 2000;
    const steps = 60;
    const increment = numericValue / steps;
    const stepDuration = duration / steps;

    statElement.textContent = '0' + suffix;

    let step = 0;
    const timer = setInterval(() => {
      step++;
      currentValue += increment;

      if (step >= steps) {
        clearInterval(timer);
        currentValue = numericValue;
      }

      let displayValue = currentValue;
      if (match[1].includes(',')) {
        displayValue = currentValue.toFixed(1).replace('.', ',');
      } else {
        displayValue = Math.round(currentValue);
      }

      statElement.textContent = displayValue + suffix;
    }, stepDuration);
  }

  bindEvents() {
    const resizeHandler = () => {
      this.destroy();
      setTimeout(() => this.init(), 100);
    };
    
    window.addEventListener('resize', resizeHandler);
    this.globalListeners.push({ element: window, event: 'resize', handler: resizeHandler });
    const sectionLoadHandler = (event) => {
      if (event.target === this.container || event.target.contains(this.container)) {
        this.destroy();
        setTimeout(() => this.init(), 100);
      }
    };
    
    document.addEventListener('shopify:section:load', sectionLoadHandler);
    this.globalListeners.push({ element: document, event: 'shopify:section:load', handler: sectionLoadHandler });
    const blockSelectHandler = (event) => {
      if (event.target.closest('.results-showcase')) {
        let slide, slideIndex;
        
        if (window.innerWidth >= 990) {
          slide = event.target.closest('.results-showcase__custom-slide');
          if (slide) {
            slideIndex = Array.from(slide.parentNode.children).indexOf(slide);
            this.goToSlide(slideIndex);
          }
        } else {
          slide = event.target.closest('.swiper-slide');
          if (slide && this.swiper) {
            slideIndex = Array.from(slide.parentNode.children).indexOf(slide);
            this.swiper.slideTo(slideIndex);
          }
        }
      }
    };
    
    document.addEventListener('shopify:block:select', blockSelectHandler);
    this.globalListeners.push({ element: document, event: 'shopify:block:select', handler: blockSelectHandler });
  }

  destroy() {
    if (this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }
    Object.values(this.watchIntervals).forEach(interval => {
      clearInterval(interval);
    });
    this.watchIntervals = {};
    this.globalListeners.forEach(({ element, event, handler, options }) => {
      element.removeEventListener(event, handler, options);
    });
    this.globalListeners = [];
    this.slidersState = {};

    if (this.statsObserver) {
      this.statsObserver.disconnect();
      this.statsObserver = null;
    }
    if (this.animatedStats) {
      this.animatedStats.clear();
    }

    this.customSlider = {
      wrapper: null,
      slides: [],
      currentIndex: 0,
      slideWidth: 394,
      activeSlideWidth: 472,
      gap: 12
    };

  }
}

document.addEventListener('DOMContentLoaded', function() {
  const resultsShowcaseSections = document.querySelectorAll('.results-showcase');
  resultsShowcaseSections.forEach(container => {
    new ResultsShowcaseSlider(container);
  });
});
document.addEventListener('shopify:section:load', function(event) {
  const container = event.target.querySelector('.results-showcase');
  if (container) {
    new ResultsShowcaseSlider(container);
  }
});

document.addEventListener('shopify:section:unload', function(event) {
  const container = event.target.querySelector('.results-showcase');
  if (container && container.resultsShowcaseSlider) {
    container.resultsShowcaseSlider.destroy();
  }
});